import { PaginatedResult } from '@nx-smartmonkey/shared/interfaces';
import { Project } from '../domain/project/Project';
import { Vehicle } from '../domain/vehicle/Vehicle';
import { VehicleFlat } from '../domain/vehicle/VehicleFlat';
import { vehicleRepository } from '../repositories/vehicle';
import { VehicleRepository } from '../repositories/vehicle/VehicleRepository';

export class VehicleService {
  constructor(private vehicleRepository: VehicleRepository) {}
  async fetchVehicle({ vehicleId, project }: { vehicleId: string; project: Project }): Promise<Vehicle> {
    const vehicle = await this.vehicleRepository.fetchVehicle({ vehicleId, project });
    return vehicle;
  }
  async searchVehicles({
    project,
    offset,
    limit,
    searchText,
    sortBy,
    sortDirection,
  }: {
    project: Project;
    offset?: number;
    limit?: number;
    searchText?: string;
    sortBy?: string;
    sortDirection?: string;
  }): Promise<PaginatedResult<Vehicle>> {
    const response = await this.vehicleRepository.search({
      project,
      offset,
      limit,
      searchText,
      sortBy,
      sortDirection,
    });
    return response;
  }
  async fetchFlatVehicles({ project }: { project: Project }): Promise<Array<VehicleFlat>> {
    const flatStops = await this.vehicleRepository.fetchFlatVehicles({
      projectId: project.id,
    });
    return flatStops;
  }
  async updateVehicle(vehicle: Vehicle, project: Project): Promise<Vehicle> {
    const response = await this.vehicleRepository.save(vehicle, project);
    return response;
  }
  async deleteVehicle(vehicle: Vehicle): Promise<void> {
    await this.vehicleRepository.delete(vehicle);
  }
  async updateConstraints({
    vehicleIds,
    constraints,
  }: {
    vehicleIds: string[];
    constraints: Record<string, any>;
  }): Promise<void> {
    return this.vehicleRepository.updateConstraints(vehicleIds, constraints);
  }
  async createVehicles({ vehicles, project }: { vehicles: Array<Vehicle>; project: Project }): Promise<Array<Vehicle>> {
    const createdVehicles = await this.vehicleRepository.createVehicles({ vehicles, project });
    return createdVehicles;
  }

  async deleteVehicles({ vehicleIds, project }: { vehicleIds: string[]; project: Project }) {
    return this.vehicleRepository.deleteVehicles(vehicleIds, project);
  }

  async disableVehicles({ vehicles, project }: { vehicles: Vehicle[]; project: Project }) {
    return this.vehicleRepository.disableVehicles(vehicles, project);
  }

  async enableVehicles({ vehicles, project }: { vehicles: Vehicle[]; project: Project }) {
    return this.vehicleRepository.enableVehicles(vehicles, project);
  }
}

export const vehicleService = new VehicleService(vehicleRepository);
